export default "__VITE_ASSET__01254f0a__"